/* Sipsy bundle helpers (Oct 9 2026). Shared by snippets/complete-the-set.liquid (product page)
   and snippets/complete-the-set-cart.liquid (cart drawer).

   Brand rules are IDENTICAL to the checkout discount function
   (bundles/discount-function/src/run.js): brand key = product vendor when it is a real brand,
   otherwise the brand parsed from the title; a bundle = 2+ DISTINCT products with the same key.
   Keeping both sides on one rule is what makes "SAVE $X" in the cart match what checkout gives.

   Companions are found with the storefront predictive-search JSON (vendor-restricted), not by
   scanning a collection: Liquid only exposes the first 50 products of a collection, which is why
   the suggestion used to be missing for most products. */
(function () {
  'use strict';
  if (window.SipsyBundle) return;

  var STOP = {};
  ('blanco,reposado,anejo,extra,cristalino,plata,silver,joven,tahona,high-proof,bourbon,scotch,rye,' +
   'whiskey,whisky,single,malt,mezcal,gin,rum,vodka,champagne,pinot,cabernet,chardonnay,sauvignon,' +
   'merlot,syrah,shiraz,malbec,grenache,zinfandel,riesling,rose,sparkling,brut,nv,cuvee,blanc,' +
   'reserve,rare,limited,barrel,batch,vintage,proof,bundle,pack,set,small,straight,bottled,bond,' +
   'still,strength,cask,overproof,aged,pot,tequila,original,triple,double,and,&')
    .split(',').forEach(function (w) { STOP[w] = true; });
  var GENERIC_VENDORS = { '': true, 'sipsy': true };
  var EXCLUDED = ['gift box', 'tip', 'gratuity', 'cc fee', 'delivery fee', 'gift wrap', 'bag', 'ice', 'cup', 'mixer', 'corkscrew', 'engraving'];
  var PERCENT = 0.05;
  var CAP_CENTS = 1000;

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function isExcluded(title) {
    var t = norm(title);
    // whole-word prefix, so "Ice Cold Vodka"-style product names are not mistaken for "ice"/"tip"/"bag"
    return EXCLUDED.some(function (p) { return t === p || t.indexOf(p + ' ') === 0; });
  }
  function titleBrand(title) {
    var words = String(title || '').split(' ');
    var out = [];
    for (var i = 0; i < words.length; i++) {
      var w = norm(words[i]).replace(/,/g, '');
      if (w === '-' || w.indexOf('ml') > -1 || w.indexOf('75cl') > -1) break;
      if (STOP[w]) break;
      out.push(w);
    }
    return out.length ? out.join(' ') : norm(String(title || '').split(' - ')[0] || title);
  }
  function realVendor(vendor) {
    var v = norm(vendor).trim();
    return v && !GENERIC_VENDORS[v] ? v : '';
  }
  function brandKey(vendor, title) {
    return realVendor(vendor) || titleBrand(title);
  }
  function brandLabel(vendor, title) {
    if (realVendor(vendor)) return String(vendor).trim();
    return titleBrand(title).replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  function savings(totalCents) {
    return Math.min(Math.round(totalCents * PERCENT), CAP_CENTS);
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  var searchCache = {};
  // info = { key, vendor }. Returns up to `want` available products that would really bundle.
  function findCompanions(info, excludePids, want) {
    var useVendor = !!realVendor(info.vendor);
    var q = useVendor ? info.vendor : info.key;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=' + (useVendor ? 'vendor' : 'title') +
      '&resources[options][unavailable_products]=hide';
    if (!searchCache[url]) {
      searchCache[url] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return (j && j.resources && j.resources.results && j.resources.results.products) || []; })
        .catch(function () { return []; });
    }
    return searchCache[url].then(function (list) {
      var out = [];
      for (var i = 0; i < list.length && out.length < want; i++) {
        var p = list[i];
        if (!p.available || excludePids.indexOf(Number(p.id)) > -1 || isExcluded(p.title)) continue;
        if (brandKey(p.vendor, p.title) !== info.key) continue;
        out.push(p);
      }
      return out;
    });
  }

  // Pick the variant to add: the same location option as the cart's first item when there is one,
  // otherwise the first available variant. Returns { id, price(cents) } or null.
  function resolveVariant(handle, loc) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (pr) {
        var vs = (pr && pr.variants) || [];
        var pick = null;
        if (loc) {
          for (var i = 0; i < vs.length; i++) {
            if (vs[i].available && norm(vs[i].option1) === norm(loc)) { pick = vs[i]; break; }
          }
        }
        if (!pick) {
          for (var j = 0; j < vs.length; j++) { if (vs[j].available) { pick = vs[j]; break; } }
        }
        return pick ? { id: pick.id, price: pick.price } : null;
      })
      .catch(function () { return null; });
  }

  function imgUrl(p, w) {
    var u = p.featured_image && p.featured_image.url;
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function truncate(s, n) { return s.length > n ? s.slice(0, n - 1) + '…' : s; }

  // Re-renders the cart drawer + icon from the server (used after adds Dawn does not know about).
  function refreshCartUi(open) {
    return Promise.all([
      fetch('/cart?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch('/cart?section_id=cart-icon-bubble').then(function (r) { return r.text(); })
    ]).then(function (res) {
      var parser = new DOMParser();
      var drawer = document.querySelector('cart-drawer');
      var cd = document.getElementById('CartDrawer');
      var nd = parser.parseFromString(res[0], 'text/html').querySelector('#CartDrawer');
      if (cd && nd) cd.innerHTML = nd.innerHTML;
      var nb = parser.parseFromString(res[1], 'text/html').querySelector('#cart-icon-bubble');
      var ob = document.getElementById('cart-icon-bubble');
      if (nb && ob) ob.innerHTML = nb.innerHTML;
      if (drawer) {
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
        if (open && drawer.open) drawer.open();
      }
    }).catch(function () {});
  }

  /* ---------------- Cart drawer upsell ---------------- */
  function renderCartUpsell(mount) {
    if (mount.getAttribute('data-cts-done')) return;
    mount.setAttribute('data-cts-done', '1');
    var node = mount.querySelector('script[data-cts-cart]');
    var items;
    try { items = JSON.parse(node.textContent); } catch (e) { return; }
    if (!items || !items.length) return;

    var groups = {};
    var order = [];
    var allPids = [];
    items.forEach(function (it) {
      allPids.push(Number(it.pid));
      if (isExcluded(it.title)) return;
      var k = brandKey(it.vendor, it.title);
      if (!k) return;
      if (!groups[k]) { groups[k] = { key: k, vendor: it.vendor, title: it.title, pids: [], cents: 0 }; order.push(k); }
      if (groups[k].pids.indexOf(it.pid) < 0) groups[k].pids.push(it.pid);
      groups[k].cents += Number(it.cents) || 0;
    });
    var loc = items[0].loc || '';
    var targets = order.map(function (k) { return groups[k]; })
      .filter(function (g) { return g.pids.length === 1; })
      .slice(0, 2);

    targets.forEach(function (g) {
      findCompanions(g, allPids, 1).then(function (list) {
        if (!list.length || !mount.isConnected) return null;
        var p = list[0];
        return resolveVariant(p.handle, loc).then(function (v) { return v ? { p: p, v: v } : null; });
      }).then(function (hit) {
        if (!hit || !mount.isConnected) return;
        var save = savings(g.cents + hit.v.price);
        var wrap = el('div', 'cts-cart-upsell');
        wrap.setAttribute('data-variant-id', String(hit.v.id));
        var inner = el('div', 'cts-cart-inner');
        var head = el('div', 'cts-cart-header');
        head.appendChild(el('span', 'cts-cart-title', 'Complete the ' + brandLabel(g.vendor, g.title) + ' Bundle'));
        head.appendChild(el('span', 'cts-cart-badge', 'SAVE ' + money(save)));
        var body = el('div', 'cts-cart-body');
        var src = imgUrl(hit.p, 80);
        if (src) {
          var img = el('img', 'cts-cart-img');
          img.src = src; img.alt = hit.p.title; img.width = 52; img.height = 52; img.loading = 'lazy';
          body.appendChild(img);
        }
        var info = el('div', 'cts-cart-info');
        info.appendChild(el('p', 'cts-cart-name', truncate(hit.p.title, 40)));
        info.appendChild(el('p', 'cts-cart-price', money(hit.v.price) + ' — add this to save ' + money(save) + ' at checkout'));
        body.appendChild(info);
        var btn = el('button', 'cts-cart-btn', '+ Add');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Add ' + hit.p.title + ' to cart to complete the bundle');
        body.appendChild(btn);
        inner.appendChild(head);
        inner.appendChild(body);
        wrap.appendChild(inner);
        mount.appendChild(wrap);
      });
    });
  }

  var scanTimer;
  function scan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      var mounts = document.querySelectorAll('.cts-cart-mount:not([data-cts-done])');
      for (var i = 0; i < mounts.length; i++) renderCartUpsell(mounts[i]);
      var pw = document.getElementById('cts-bundle-wrap');
      if (pw && !pw.getAttribute('data-cts-init')) initProductWidget(pw);
    }, 60);
  }

  /* ---------------- Product page widget ---------------- */
  function initProductWidget(wrap) {
    wrap.setAttribute('data-cts-init', '1');
    var pid = Number(wrap.getAttribute('data-pid'));
    var vendor = wrap.getAttribute('data-vendor') || '';
    var title = wrap.getAttribute('data-title') || '';
    var cents = Number(wrap.getAttribute('data-cents')) || 0;
    var key = brandKey(vendor, title);
    var rendered = false;
    var busy = false;

    function build(cart) {
      if (rendered || busy) return;
      var inCart = cart.items.some(function (i) { return i.product_id === pid; });
      if (!inCart) return;
      var allPids = cart.items.map(function (i) { return i.product_id; });
      // brand already has 2+ distinct products in the cart -> the bundle is already earned
      var sameBrand = {};
      cart.items.forEach(function (i) {
        if (brandKey(i.vendor, i.product_title) === key) sameBrand[i.product_id] = true;
      });
      if (Object.keys(sameBrand).length > 1) return;
      busy = true;
      var loc = (cart.items[0] && cart.items[0].variant_options && cart.items[0].variant_options[0]) || '';
      findCompanions({ key: key, vendor: vendor }, allPids, 2).then(function (list) {
        if (!list.length) { busy = false; return; }
        return Promise.all(list.map(function (p) {
          return resolveVariant(p.handle, loc).then(function (v) { return v ? { p: p, v: v } : null; });
        })).then(function (hits) {
          hits = hits.filter(Boolean);
          busy = false;
          if (!hits.length) return;
          rendered = true;
          var total = cents + hits.reduce(function (s, h) { return s + h.v.price; }, 0);
          var save = savings(total);
          wrap.textContent = '';
          var box = el('div', 'cts-box');
          var head = el('div', 'cts-head');
          head.appendChild(el('span', 'cts-title', 'Complete the Set'));
          head.appendChild(el('span', 'cts-badge', 'SAVE ' + money(save)));
          var row = el('div', 'cts-items');
          hits.forEach(function (h, idx) {
            if (idx > 0) { var sep = el('span', 'cts-sep', '+'); sep.setAttribute('aria-hidden', 'true'); row.appendChild(sep); }
            var item = el('div', 'cts-item');
            var src = imgUrl(h.p, 120);
            if (src) { var im = el('img'); im.src = src; im.alt = h.p.title; im.width = 60; im.height = 60; im.loading = 'lazy'; item.appendChild(im); }
            var inf = el('div', 'cts-item-info');
            inf.appendChild(el('p', 'cts-item-name', truncate(h.p.title, 40)));
            inf.appendChild(el('p', 'cts-item-price', money(h.v.price)));
            item.appendChild(inf);
            row.appendChild(item);
          });
          var foot = el('div', 'cts-foot');
          foot.appendChild(el('p', 'cts-save-label', 'Add to your cart to save ' + money(save) + ' at checkout'));
          var btn = el('button', 'cts-btn', 'Add to Complete the Bundle  ·  Save ' + money(save));
          btn.type = 'button';
          btn.setAttribute('aria-label', 'Add to cart to complete the bundle');
          foot.appendChild(btn);
          foot.appendChild(el('p', 'cts-footnote', '5% bundle discount applied automatically at checkout'));
          box.appendChild(head); box.appendChild(row); box.appendChild(foot);
          wrap.appendChild(box);
          wrap.style.removeProperty('display');
          btn.addEventListener('click', function () {
            btn.disabled = true;
            btn.textContent = 'Adding to cart…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: hits.map(function (h) { return { id: h.v.id, quantity: 1 }; }) })
            }).then(function (res) {
              if (!res.ok) throw new Error('Cart error ' + res.status);
              wrap.textContent = '';
              var ok = el('div', 'cts-success', '✓ Bundle added to cart! ');
              ok.style.padding = '14px 0';
              var a = el('a', null, 'View cart →'); a.href = '/cart';
              ok.appendChild(a);
              wrap.appendChild(ok);
              refreshCartUi(true);
            }).catch(function () {
              btn.disabled = false;
              btn.textContent = 'Try Again';
            });
          });
        });
      }).catch(function () { busy = false; });
    }

    function check() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(build).catch(function () {});
    }
    check();
    ['cart:refresh', 'cart:updated', 'cart-drawer:open'].forEach(function (evt) {
      document.addEventListener(evt, check);
      document.documentElement.addEventListener(evt, check);
    });
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) new MutationObserver(check).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  window.SipsyBundle = {
    brandKey: brandKey, brandLabel: brandLabel, savings: savings, money: money,
    findCompanions: findCompanions, resolveVariant: resolveVariant, refreshCartUi: refreshCartUi
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // The cart drawer is re-rendered with innerHTML (scripts inside do not run), so watch for new mounts.
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
